import RasterClass, * as RasterModule from './../../node_modules/ol/source/Raster.js';

class Raster extends RasterClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in RasterModule) {
    if (key !== "default") {
        Raster[key] = RasterModule[key];
    }
}

export default Raster;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/Raster.js';